import React from "react";
import { Box, Typography } from "@mui/material";
import "./style.scss";
import ComodyVerticalIcon from "../Icons/ComodyVerticalIcon";

export default function CustomLoader({
  height = "50vh",
  text = "",
  color = "primary",
  size = 12,
}) {
  return (
    <div>
      <Box
        sx={{
          height,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <ComodyVerticalIcon
          color={color}
          size={size}
          className="waviy"
        />
        <Box sx={{ my: 1 }} />
        <Typography align="center">{text}</Typography>
      </Box>
    </div>
  );
}
